function ModalComponent({ id, title, children, size = 'xl', showHeader = true }) {
  //  rounded-top-3
  return (
    <div className='modal fade' id={id}>
      <div className={`modal-dialog modal-${size}`}>
        <div className='modal-content'>
          {showHeader && (
            <div className='modal-header bg-theme bg-opacity-10  '>
              <h5 className='modal-title'>{title}</h5>
              <button type='button' className='btn-close' data-bs-dismiss='modal'></button>
            </div>
          )}

          <div className='modal-body'>{children}</div>
        </div>
      </div>
    </div>
  );
}

export default ModalComponent;
